<div class="dashboard-wrapper">
  <section class="dashboard-main">
    <div class="widget agenda-widget">
      <div class="loader-container">
        <mat-progress-bar mode="indeterminate" *ngIf="isCalendarLoading || isTasksLoading">
        </mat-progress-bar>
      </div>

      <div class="widget-header">
        <div class="header-left">
          <mat-icon>calendar_month</mat-icon>

          <div class="title-group">
            <h3 (click)="today()" style="cursor: pointer;">Week overview</h3>

            <mat-button-toggle-group class="view-selector" aria-label="View Mode" (change)="onViewChange($event)"
              value="week">
              <mat-button-toggle value="week">Week</mat-button-toggle>
              <mat-button-toggle value="next7">7 days</mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        </div>

        <div class="header-right">
          <div class="nav-controls">
            <button mat-icon-button (click)="previousWeek()" matTooltip="Previous week">
              <mat-icon>chevron_left</mat-icon>
            </button>

            <span class="date-range">
              {{ getWeekRangeString(weekPlan[0]?.date, weekPlan[6]?.date) }}
            </span>

            <button mat-icon-button (click)="nextWeek()" matTooltip="Next week">
              <mat-icon>chevron_right</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div class="widget-content agenda-content" *ngIf="weekPlan?.length">
        <div class="week-grid">
          <div class="corner-cell"></div>

          <div class="days-header-shell">
            <div class="days-header">
              <div class="day-header" *ngFor="let day of weekPlan" [class.today]="day.isToday">
                <span class="day-name">{{ day.date | date:'EEE' }}</span>
                <span class="day-number">{{ day.date | date:'dd' }}</span>
              </div>
            </div>
            <div class="scrollbar-spacer"></div>
          </div>

          <div class="all-day-label">All day</div>

          <div class="all-day-row-shell">
            <div class="all-day-row">
              <div class="all-day-cell" *ngFor="let day of weekPlan; let dayIndex = index"
                (contextmenu)="onAllDayContextMenu($event, day.date)">

                <div class="multi-day-event"
                  *ngFor="let event of getMultiDayEventsStartingOn(dayIndex); let rowIndex = index"
                  [style.top.px]="6 + (getEventLane(event) * 26)" [style.width.%]="getMultiDayWidthPercent(event)"
                  [style.background]="event.calendarColor || '#308527'" [matTooltip]="buildEventTooltip(event)"
                  matTooltipClass="multi-line-tooltip" (click)="openNote(event)"
                  (contextmenu)="editEventEnabled ? editEvent($event, event) : $event.preventDefault()">
                  {{ event.title }}
                </div>
              </div>
            </div>
            <div class="scrollbar-spacer"></div>
          </div>

          <div #timeGridScroll class="time-grid-scroll">
            <div class="time-column">
              <div class="time-slot-label" *ngFor="let hour of hours" [style.height.px]="hourSlotHeight">
                {{ formatHour(hour) }}
              </div>
            </div>

            <div class="time-grid" [style.height.px]="hours.length * hourSlotHeight">

              <div class="day-column" *ngFor="let day of weekPlan">
                <ng-container *ngFor="let hour of hours">
                  <!-- Eerste 30 min (top half) -->
                  <div *ngIf="editEventEnabled" class="half-hour-line top"
                    (contextmenu)="onCellContextMenu($event, day.date, hour, 0)"
                    [matTooltip]="'Right-click to add event at ' + formatHour(hour)">
                  </div>
                  <!-- Tweede 30 min (bottom half) -->
                  <div *ngIf="editEventEnabled" class="half-hour-line bottom"
                    (contextmenu)="onCellContextMenu($event, day.date, hour, 30)"
                    [matTooltip]="'Right-click to add event at ' + formatHour(hour) + ':30'">
                  </div>
                </ng-container>

                <div class="selection-frame"
                  *ngIf="selectedSlot && selectedSlot.date.toDateString() === day.date.toDateString()"
                  [style.top.px]="selectedSlot.topPx" [style.height.px]="selectedSlot.heightPx">
                </div>

                <div class="timed-event" *ngFor="let event of getTimedEventsForDay(day)"
                  [style.top.px]="getEventTop(event)" [style.height.px]="getEventHeight(event)"
                  [style.left.%]="getEventLeft(event, day)" [style.width.%]="getEventWidth(event, day)"
                  [style.border-left-color]="event.calendarColor || '#308527'"
                  [style.background]="toEventBackground(event.calendarColor)" [matTooltip]="buildEventTooltip(event)"
                  matTooltipClass="multi-line-tooltip" (click)="openNote(event)"
                  (contextmenu)="editEventEnabled ? editEvent($event, event) : $event.preventDefault()">
                  <span class="event-time">{{ formatEventTime(event) }}</span>
                  <span class="event-title">{{ event.title }}</span>
                </div>

                <div class="empty-day-label"
                  *ngIf="getTimedEventsForDay(day).length === 0 && !hasMultiDayEventOnDay(day)">
                  Free
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="widget tasks-widget">
      <div class="widget-header">
        <div class="header-left">
          <mat-icon>check_circle_outline</mat-icon>
          <div class="title-group">
            <h3>Upcoming tasks</h3>
          </div>
        </div>

        <div class="header-right">
          <!-- Icoon knop -->
          <button mat-icon-button [matMenuTriggerFor]="filterMenu" aria-label="Filter">
            <mat-icon>filter_list</mat-icon>
          </button>

          <!-- Dropdown Menu -->
          <mat-menu #filterMenu="matMenu" class="task-filter-panel">
            <div class="filter-panel-content" (click)="$event.stopPropagation()">

              <!-- 1. Kalender Dropdown (mat-select) -->
              <mat-form-field appearance="outline" class="full-width-field">
                <mat-label>Calendar</mat-label>
                <mat-select [value]="selectedCalendarForTaskOverview" [compareWith]="functions.objectComparisonFunction" (selectionChange)="onCalendarSelectChange($event.value)">
                  <mat-option *ngFor="let cal of calendars" [value]="cal">
                    {{ getCalendarLabel(cal) }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <!-- 2. Outlook Days Spinner -->
              <div class="outlook-row">
                <label for="outlook-input" class="outlook-label">Outlook (days)</label>
                <input id="outlook-input" type="number" class="outlook-input" [value]="outlookDays" min="1" max="365"
                  (change)="onOutlookDaysChange(+$any($event.target).value)" />
              </div>

            </div>
          </mat-menu>

        </div>

      </div>

      <div class="widget-content dashboard-card-list">
        <div class="custom-task-card" *ngFor="let task of upcomingTasks" (dblclick)="editTask(task)">
          <div class="card-accent" [style.background-color]="isTaskOverdue(task) ? '#ef4444' : '#66bb6a'">
          </div>

          <div class="card-main-content task-card-content" [ngStyle]="getTaskCardStyle(task)">
            <div class="task-text-group">
              <span class="task-title">{{ task.title }}</span>
              <span class="task-date" *ngIf="task.dueDate">{{ task.dueDate | date:'mediumDate' }}</span>
            </div>
          </div>
        </div>
      </div>

      <button *ngIf="currentCalendar != null" mat-fab color="primary" class="fab-tasks-widget" (click)="addTask()"
        matTooltip="Add task">
        <mat-icon>add</mat-icon>
      </button>

    </div>
  </section>
</div>